import moment from "moment";

export const hourToMinutes = hour => {
  if (hour !== undefined && hour !== null) {
    let splitTime = hour.split(":");
    let hoursInt = Number.parseInt(splitTime[0]);
    let miutesInt = Number.parseInt(splitTime[1]);
    return hoursInt * 60 + miutesInt;
  }
  return null;
};

export const minutesToHour = minutes => {
  if (minutes !== undefined && minutes !== null) {
    var _hours = Math.floor(minutes / 60);
    var _minutes = minutes % 60;
    _hours = _hours < 10 ? "0" + _hours : _hours;
    _minutes = _minutes < 10 ? "0" + _minutes : _minutes;
    return _hours + ":" + _minutes;
  } else {
    return null;
  }
};

export const minutesFormat = minutes => {
  var _hours = Math.floor(minutes / 60);
  var _minutes = minutes % 60;
  _hours = _hours > 0 ? _hours + "h" : "";
  _minutes = _minutes > 0 ? _minutes + "m" : "";
  return _hours + " " + _minutes;
};

export const booleanToText = (bool, yes, no) => {
  return bool === true ? yes : no;
};

export const decimalOnlyField = evt => {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
    evt.preventDefault();
  } else {
    return true;
  }
};

export const integerOnlyField = evt => {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    evt.preventDefault();
  } else {
    return true;
  }
};

export const transformDate = (date, format) => {
  if (!date) return null;
  return moment(date).format(format);
};

export const parseExcelDate = (date, format) => {
  console.debug("parseExcelDate: " + date);
  if (date === null) return null;
  if (isNaN(date)) {
    return moment(date, format).valueOf();
  } else {
    return new Date(Math.round((date - 25569) * 86400 * 1000)).getTime();
  }
};

export const dateToIso = (date, format) => {
  console.debug("dateToIso: " + date);
  if (date === null) return null;
  if (isNaN(date)) {
    return moment(date, format).format("YYYY-MM-DD");
  } else {
    return new Date(Math.round((date - 25569) * 86400 * 1000)).getTime();
  }
};

export const excelTimeToMinutes = time => {
  console.debug("excelTimeToMinutes: " + time);
  if (time === null) return null;
  if (isNaN(time)) {
    return hourToMinutes(time);
  } else {
    return time * 24 * 60;
  }
};
